<template>
  <div class="MyQuestionaire">
    <div class="MyQuestionaire-dv">
      <div class="MyQuestionaire-dvh">
        <h1>我的问卷</h1>
      </div>
      <div class="MyQuestionaire-dvul">
        <ul>
          <li @click="changespan">
            <p :class="{ active: falge == true }">
              未完成问卷
              <i class="deg1" v-if="total >= 1 && total < 100">
                {{ total }}
              </i>
              <i class="deg1" v-if="total >= 100">
                ┉
              </i>
            </p>
            <span v-show="falge" />
          </li>
          <li @click="changespan1">
            <p :class="{ active: falge1 == true }">
              历史问卷
              <i class="deg1" v-if="total1 >= 1 && total1 < 100">
                {{ total1 }}
              </i>
              <i class="deg1" v-if="total1 >= 100">
                ┉
              </i>
            </p>
            <span v-show="falge1" />
          </li>
        </ul>
      </div>
      <div class="MyQuestionaire-dv4" v-show="kong">
        <!-- <img src="../../assets/img-kong.png" > -->
        <div class="img-kong" />
        <span>这里空空如也哦~</span>
      </div>
    </div>
    <!-- 未完成问卷 -->
    <div class="MyQuestionaire-dv1" v-show="falge">
      <div class="MyQuestionaire-content">
        <ul>
          <li v-for="(item, index) in list" :key="index">
            <div class="dv_flex">
              <h2>{{ item.form_name }}</h2>
              <span
                >起止时间：{{ item.startTime | time }}-{{
                  item.entTime | time
                }}</span
              >
            </div>
            <p @click="jumpFilling(item.formId, item.form_name)">
              开始答卷
              <span class="kaishidajuan_img" />
              <!-- <img src="../../assets/kaishidajuan.png" > -->
            </p>
          </li>
        </ul>
      </div>
    </div>
    <!-- 历史问卷 -->
    <div class="MyQuestionaire-dv2" v-show="falge1">
      <div class="MyQuestionaire-conten2">
        <ul>
          <li v-for="(item, index) in list1" :key="index">
            <div class="dv_flex2">
              <h2>{{ item.form_name }}</h2>
              <span
                >起止时间：{{ item.startTime | time }}-{{
                  item.entTime | time
                }}</span
              >
            </div>
            <div
              class="dvRight_flex2"
              @click="jumpComplete(item.formId, item.form_name)"
            >
              查看
            </div>
          </li>
        </ul>
      </div>
    </div>
    <back-to :path="'/'" />
  </div>
</template>
<script>
import backTo from "@/components/back";
import api from "@/api";
import { formatDate } from "@/utils/utils";
export default {
  components: { backTo },
  data() {
    return {
      total: "",
      total1: "",
      falge: true,
      falge1: false,
      kong: false,
      page: 1,
      pageSize: 1000,
      list: [],
      list1: []
    };
  },
  methods: {
    init() {
      if (this.$route.query.index == 1 || this.$route.query.index == 10) {
        this.changespan1();
        return;
      }

      this.changespan();
    },
    //未完成问卷
    changespan() {
      this.falge = true;
      this.falge1 = false;
      if (this.list.length == 0) {
        this.kong = true;
      } else {
        this.kong = false;
      }
    },
    //历史问卷
    changespan1() {
      this.falge = false;
      this.falge1 = true;
      if (this.list1.length == 0) {
        this.kong = true;
      } else {
        this.kong = false;
      }
    },
    //开始答卷
    jumpFilling(ids, name) {
      this.$router.push({
        path: "/Questionnairefilling",
        query: { formId: ids, names: name }
      });
    },
    //查看
    jumpComplete(ids, name) {
      this.$router.push({
        path: "/Questionnairedetails",
        query: { formId: ids, names: name }
      });
    },
    //未完成问卷列表
    listUnFinish() {
      let key = {
        page: this.page,
        rows: this.pageSize
      };
      this.$post(api.questionnaire.listUnFinish(), key).then(res => {
        if (res.status == 1) {
          this.list = res.data.list;
          this.total = res.data.total;
        }
        this.init();
      });
    },
    //历史问卷  historyFinish
    historyFinish() {
      let key = {
        page: this.page,
        rows: this.pageSize
      };
      this.$post(api.questionnaire.historyFinish(), key).then(res => {
        if (res.status == 1) {
          this.list1 = res.data.list;
          this.total1 = res.data.total;
        }
        this.init();
      });
    }
  },
  filters: {
    time(val) {
      return val ? formatDate(val, "yyyy-MM-dd") : "";
    }
  },
  created() {
    this.listUnFinish();
    this.historyFinish();
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.MyQuestionaire {
  .MyQuestionaire-dv {
    width: 100%;
    position: fixed;
    top: 0;
    background-color: #fff;
    .MyQuestionaire-dvh {
      padding: 39px 290px;
      h1 {
        font-size: 36px;
        text-align: center;
        color: #323232;
        font-weight: 600;
        letter-spacing: 5px;
      }
    }
    .MyQuestionaire-dvul {
      ul {
        display: flex;
        li {
          list-style: none;
          color: #969696;
          font-size: 26px;
          text-align: center;
          font-weight: 600;
          flex: 1;
          span {
            width: 50px;
            height: 8px;
            background: rgba(3, 177, 135, 1);
            border-radius: 4px;
            display: inline-block;
            margin-top: 20px;
          }
          p {
            position: relative;
            .deg1 {
              font-style: normal;
              color: #fff;
              background: rgba(248, 89, 89, 1);
              border-radius: 50%;
              width: 33px;
              height: 33px;
              display: inline-block;
              font-size: 24px;
              margin-left: 5px;
              line-height: 33px;
              position: absolute;
              top: 0;
              right: 79px;
              box-sizing: border-box;
            }
          }

          .active {
            color: $color-primary;
          }
        }
      }
    }
  }
  .MyQuestionaire-dv1 {
    .MyQuestionaire-content {
      padding: 39px 30px;
      ul {
        margin-top: 200px;
        li {
          list-style: none;
          background: rgba(255, 255, 255, 1);
          box-shadow: $box-shadow;
          border-radius: 10px;
          padding: 39px 24px;
          display: flex;
          margin-bottom: 30px;
          p {
            font-size: 20px;
            font-family: PingFangSC;
            font-weight: 400;
            color: $color-primary;
            margin-top: 24px;
            // img{
            //     width:44px;
            //     height:44px;
            //     margin-top: -3px;
            //     margin-left: 20px;
            //     float: right;
            // }
            .kaishidajuan_img {
              width: 5.867vw;
              margin-top: -3px;
              margin-left: 20px;
              height: 6vw;
              background: url("../../assets/kaishidajuan.png") no-repeat center
                center;
              background-size: 100% 100%;
              display: block;
              float: right;
            }
          }
          .dv_flex {
            flex: 1;
            h2 {
              font-size: 24px;
              font-family: PingFangSC;
              font-weight: 500;
              color: #323232;
            }
            span {
              font-size: 20px;
              font-family: PingFangSC;
              font-weight: 400;
              color: rgba(150, 150, 150, 1);
              margin-top: 29px;
              display: block;
            }
          }
          .dv_flex1 {
            font-size: 20px;
            font-family: PingFangSC;
            font-weight: 400;
            color: rgba(3, 177, 135, 1);
            margin-top: 24px;
            width: 102px;
            height: 46px;
            border: 1px solid rgba(3, 177, 135, 1);
            border-radius: 22px;
          }
        }
      }
    }
  }
  .MyQuestionaire-dv2 {
    .MyQuestionaire-conten2 {
      padding: 39px 30px;
      ul {
        margin-top: 200px;
        li {
          list-style: none;
          background: rgba(255, 255, 255, 1);
          box-shadow: $box-shadow;
          border-radius: 10px;
          padding: 39px 24px;
          display: flex;
          margin-bottom: 30px;
          .dv_flex2 {
            flex: 1;
            h2 {
              font-size: 24px;
              font-family: PingFangSC;
              font-weight: 500;
              color: #323232;
            }
            span {
              font-size: 20px;
              font-family: PingFangSC;
              font-weight: 400;
              color: rgba(150, 150, 150, 1);
              margin-top: 29px;
              display: block;
            }
          }
          .dvRight_flex2 {
            font-size: 20px;
            font-family: PingFangSC;
            font-weight: 400;
            color: $color-primary;
            text-align: center;
            margin-top: 24px;
            width: 102px;
            height: 46px;
            border: 1px solid rgba(3, 177, 135, 1);
            border-radius: 22px;
            padding-top: 2px;
          }
        }
      }
    }
  }

  .MyQuestionaire-dv4 {
    margin-top: 320px;
    .img-kong {
      width: 100%;
      height: 300px;
      background: url("../../assets/img-kong.png") no-repeat center center;
      background-size: 100% 100%;
    }
    span {
      font-size: 30px;
      font-family: PingFangSC;
      font-weight: 400;
      color: rgba(142, 233, 202, 1);
      text-align: center;
      display: block;
    }
  }
}
</style>
